import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { Page } from '@interfaces/page';
import { SortingPagingData } from '@helpers/sorting-paging-data';
import { SmsCampaignConfig } from '../_models/sms-campaign-config.model';

const apiServerUrl       = environment.apiBaseURL;
const baseUrl            = apiServerUrl + '/sms-campaign-config';
const findByIdUrl        = baseUrl + '/{id}';
const saveUrl            = baseUrl;
const findPageableUrl    = baseUrl + '/pageable';
const countPageableUrl   = baseUrl + '/pageable-count';

@Injectable({
  providedIn: 'root'
})
export class SmsCampaignConfigService {

  constructor(private http: HttpClient) { }

  public findById(id: number): Observable<SmsCampaignConfig> {
    return this.http.get<SmsCampaignConfig>(findByIdUrl.replace('{id}', `${id}`));
  }

  public save(dto: SmsCampaignConfig): Observable<number> {
    return this.http.post<number>(saveUrl, dto);
  }

  public pageable(sortingPaging: SortingPagingData, filters: any): Observable<[Page<SmsCampaignConfig>, number]> {
    return forkJoin([
      this.findPageable(sortingPaging, filters),
      this.countAll(filters)
    ]);
  }

  public findPageable(sortingPaging: SortingPagingData, filters: any): Observable<Page<SmsCampaignConfig>> {
    let params = new HttpParams()
      .set('page', sortingPaging.pageNumber.toString())
      .set('pageSize', sortingPaging.pageSize.toString());

    params = this.appendFilters(params, filters);

    return this.http.get<Page<SmsCampaignConfig>>(findPageableUrl, { params });
  }

  public countAll(filters: any): Observable<number> {
    let params = this.appendFilters(new HttpParams(), filters);

    return this.http.get<number>(countPageableUrl, { params });
  }

  private appendFilters(params: HttpParams, filters: any): HttpParams {
    if (filters?.name) {
      params = params.set('name', filters.name);
    }
    // isActive is a tri-state filter: null means "any", and false is meaningful.
    if (filters?.isActive != null && filters.isActive !== '') {
      params = params.set('isActive', filters.isActive.toString());
    }
    if (filters?.technicalPointMobileAppId != null) {
      params = params.set('technicalPointMobileAppId', filters.technicalPointMobileAppId.toString());
    }
    if (filters?.incomingWay) {
      params = params.set('incomingWay', filters.incomingWay);
    }
    return params;
  }
}
